import { Component, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnDestroy {
  private header: HTMLElement | null = null;
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      if (typeof document !== 'undefined') {
        this.header = document.querySelector('.header');
      }

      if (window.scrollY > 30) {
        this.header?.classList.add('scrolled');
      } else {
        this.header?.classList.remove('scrolled');
      }

      window.onscroll = () => {
        if (this.header) {
          if (window.scrollY > 30) {
            this.header.classList.add('scrolled');
          } else {
            this.header.classList.remove('scrolled');
          }
        }
      };
    }
  }

  ngOnDestroy() {
    if (this.isBrowser && window) {
      window.onscroll = null;
      this.header?.classList.add('scrolled');
    }
  }
}
